import React, { createContext, useContext, useState, useEffect } from 'react';
import { currentCenter } from '../data/centerPortalData';

const CenterAuthContext = createContext(null);

export const CenterAuthProvider = ({ children }) => {
  const [center, setCenter] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const savedCenter = localStorage.getItem('sba_center_user');
    if (savedCenter) {
      setCenter(JSON.parse(savedCenter));
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const login = async (email, password) => {
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    if (email === 'delhi@sba-center.org' && password === 'demo123') {
      setCenter(currentCenter);
      setIsAuthenticated(true);
      localStorage.setItem('sba_center_user', JSON.stringify(currentCenter));
      return { success: true };
    }
    return { success: false, error: 'Invalid credentials' };
  };

  const logout = () => {
    setCenter(null);
    setIsAuthenticated(false);
    localStorage.removeItem('sba_center_user');
  };

  return (
    <CenterAuthContext.Provider value={{ center, isLoading, isAuthenticated, login, logout }}>
      {children}
    </CenterAuthContext.Provider>
  );
};

export const useCenterAuth = () => {
  const context = useContext(CenterAuthContext);
  if (!context) {
    throw new Error('useCenterAuth must be used within a CenterAuthProvider');
  }
  return context;
};
